export default __webpack_public_path__ + "static/Supply-Light-1fec2a46d582bc74b91ff750d2dfbb70.woff";